const Lamborghini = [
    {
        ID: "lamborghini_1",
        name: "Huracan Evo",
        brand: "Lamborghini",
        price: 18,
        engine: "V10 5.2L",
        max: 325,
        version: "AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/BGKmn8T/ev.webp",
        link: "/brands/lamborghini/huracan-evo",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_2",
        name: "Aventador S",
        brand: "Lamborghini",
        price: 45,
        engine: "V12 6.5L",
        max: 350,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/PMxDZSc/s.webp",
        link: "/brands/lamborghini/aventador-s",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_3",
        name: "Aventador Ultimae",
        brand: "Lamborghini",
        price: 37.5,
        engine: "V12 6.5L",
        max: 355,
        version: "AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/wLp2cYv/ul.webp",
        link: "/brands/lamborghini/aventador-ultimae",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },

    {
        ID: "lamborghini_4",
        name: "Centenario",
        brand: "Lamborghini",
        price: 44.5,
        engine: "V12 6.5L",
        max: 350,
        version: "7s ISR",
        type: "Coupe",
        avatar: "https://i.ibb.co/5WGHNpS/Centenario.webp",
        link: "/brands/lamborghini/centenario",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },

    {
        ID: "lamborghini_5",
        name: "Veneno",
        brand: "Lamborghini",
        price: 192,
        engine: "V12 6.5L",
        max: 355,
        version: "ISR 7",
        type: "Coupe",
        avatar: "https://i.ibb.co/b7yfLJ5/Veneno.webp",
        link: "/brands/lamborghini/veneno",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_6",
        name: "Sesto Elemento",
        brand: "Lamborghini",
        price: 223,
        engine: "V10 5.2L",
        max: 300,
        version: "6",
        type: "Coupe",
        avatar: "https://i.ibb.co/8bjdgWq/ele.webp",
        link: "/brands/lamborghini/sesto-elemento",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_7",
        name: "Sian",
        brand: "Lamborghini",
        price: 84.5,
        engine: "V12 6.5L",
        max: 350,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/mG3dGz1/sian.webp",
        link: "/brands/lamborghini/sian",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_8",
        name: "SC18",
        brand: "Lamborghini",
        price: 160,
        engine: "V12 6.5L",
        max: 350,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/zxzMS7y/sc18.webp",
        link: "/brands/lamborghini/sc18",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "lamborghini_9",
        name: "Urus",
        brand: "Lamborghini",
        price: 13.1,
        engine: "V8 Twin-Turbo 4.0L",
        max: 305,
        version: "8 AT",
        type: "SUV",
        avatar: "https://i.ibb.co/sWrzCNG/uruss.webp",
        link: "/brands/lamborghini/urus",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
        review: `<h1>
        Đánh giá Lamborghini Urus - Siêu SUV cao cấp nhà "Bò"
    </h1>
    <p>
        Lamborghini Urus là Siêu xe thể thao đa dụng đầu tiên
        trên thế giới kết hợp linh hồn của một chiếc siêu xe thể
        thao với chức năng của một chiếc SUV. Được trang bị động
        cơ tăng áp kép V8 4.0 lít sản sinh công suất 650 CV và
        mô-men xoắn 850 Nm, Urus tăng tốc từ 0 lên 62 dặm / giờ
        trong 3,6 giây và đạt tốc độ tối đa 190 dặm / giờ. Thiết
        kế, hiệu suất, động lực lái và cảm xúc lái dễ dàng chảy
        vào cách tiếp cận có tầm nhìn xa này của Lamborghini
        DNA.
    </p>
    <img
        alt=" "
        src="https://autopro8.mediacdn.vn/2021/12/24/lamborghini-urus-by-mansory-and-mtm-1640330234695999743841.jpg"
    />
    <i>Lamborghini Urus bản đen mạnh mẽ</i>
    <p>
        Lamborghini Urus là Siêu xe thể thao đa dụng đầu tiên
        trên thế giới kết hợp linh hồn của một chiếc siêu xe thể
        thao với chức năng của một chiếc SUV. Được trang bị động
        cơ tăng áp kép V8 4.0 lít sản sinh công suất 650 CV và
        mô-men xoắn 850 Nm, Urus tăng tốc từ 0 lên 62 dặm / giờ
        trong 3,6 giây và đạt tốc độ tối đa 190 dặm / giờ. Thiết
        kế, hiệu suất, động lực lái và cảm xúc lái dễ dàng chảy
        vào cách tiếp cận có tầm nhìn xa này của Lamborghini
        DNA.
    </p>
    <img
        alt=" "
        src="https://autopro8.mediacdn.vn/2021/12/24/lamborghini-urus-by-mansory-and-mtm-1640330234695999743841.jpg"
    />
    <i>Lamborghini Urus bản đen mạnh mẽ</i>
    <p>
        Lamborghini Urus là Siêu xe thể thao đa dụng đầu tiên
        trên thế giới kết hợp linh hồn của một chiếc siêu xe thể
        thao với chức năng của một chiếc SUV. Được trang bị động
        cơ tăng áp kép V8 4.0 lít sản sinh công suất 650 CV và
        mô-men xoắn 850 Nm, Urus tăng tốc từ 0 lên 62 dặm / giờ
        trong 3,6 giây và đạt tốc độ tối đa 190 dặm / giờ. Thiết
        kế, hiệu suất, động lực lái và cảm xúc lái dễ dàng chảy
        vào cách tiếp cận có tầm nhìn xa này của Lamborghini
        DNA.
    </p>
    `,
    },
];
export default Lamborghini;
